import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { ContentAnimDirective } from '../../product-layout/content-anim.directive';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { EditorTextComponent } from '../editor-text/editor-text.component';

@Component({
  selector: 'calsoft-text-with-text',
  imports: [DefaultLayoutDirective, ContentAnimDirective, DefaultFlexDirective, DefaultLayoutAlignDirective, EditorTextComponent],
  templateUrl: './text-with-text.component.html',
  styleUrl: './text-with-text.component.scss'
})
export class TextWithTextComponent {

   public serverPath = environment.commonImageApi + '/commonSlider/';

  public serverPath1 = environment.commonImageApi + '/home/';

  @Input() item: any;

  @Input() img: any;

  @Input() data: any;
  
}
